/**
 * CO-933 — keeping signed numbers whole inside RTL text. See components/ui/SignedValue.tsx for the
 * element form (<SignedValue>, <SignedText>); these are the string forms.
 */

const LRI = '\u2066';
const PDI = '\u2069';

/**
 * Wrap a string in LTR isolate marks (U+2066 … U+2069). For places that only take a string: an
 * interpolation value inside a translated sentence, an SVG/recharts label, a title attribute.
 */
export const ltrIsolate = (text: string | number): string => `${LRI}${text}${PDI}`;

/**
 * "+3", "-2", "0": the number with an explicit "+" for positive values. Keeps the hyphen-minus the
 * call sites printed before, so en/fr text is unchanged. `digits` fixes the decimals (toFixed).
 */
export const formatSigned = (value: number, digits?: number): string => {
  const body = digits == null ? String(value) : value.toFixed(digits);
  return value > 0 ? `+${body}` : body;
};
